import { Route, Routes } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import { BodyRouteClass } from './components/BodyRouteClass';
import { SiteHeader } from './components/SiteHeader';
import { LandingPage } from './pages/LandingPage';
import { PlayPage } from './pages/PlayPage';
import { PracticePage } from './pages/PracticePage';
import { PremiumPage } from './pages/PremiumPage';
import { GalleryPage } from './pages/GalleryPage';
import { CreditsPage } from './pages/CreditsPage';
import { ResultPage } from './pages/ResultPage';
import { LeaderboardPage } from './pages/LeaderboardPage';
import { LoginPage } from './pages/LoginPage';
import { AuthCallbackPage, AuthVerifyPage } from './pages/AuthPages';
import { ProfilePage, AdminPage } from './pages/ProfilePage';

export function App() {
  return (
    <AuthProvider>
      <BodyRouteClass />
      <SiteHeader />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/play" element={<PlayPage />} />
        <Route path="/practice" element={<PracticePage />} />
        <Route path="/premium" element={<PremiumPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/credits" element={<CreditsPage />} />
        <Route path="/result" element={<ResultPage />} />
        <Route path="/leaderboard" element={<LeaderboardPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/verify" element={<AuthVerifyPage />} />
        <Route path="/auth/callback" element={<AuthCallbackPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </AuthProvider>
  );
}
